module.exports = __webpack_public_path__ + "img/agence-europe-energie.3e089fa7.svg";